import { Resource as p, API as n } from "@coveo/platform-client";
const r = class r extends p {
  get(e, t, s) {
    return this.api.get(o(e, t, s));
  }
  create(e) {
    return this.api.post(r.baseUrl, e);
  }
  update(e, t) {
    return this.api.put(`${r.baseUrl}/${e}`, t);
  }
  delete(e, t, s) {
    return this.api.delete(o(e, t, s));
  }
};
r.baseUrl = `/rest/organizations/${n.orgPlaceholder}/commerce/v2/configurations/rules`;
let a = r;
const o = (i, e, t) => [a.baseUrl, i.toUpperCase(), e.toUpperCase(), t].join("/");
export {
  a as Rules
};
//# sourceMappingURL=Rules.js.map
